<template>
    <transition name="fade">
        <nav class="sidebar">
            <router-link :to="i18nLink()" class="sidebar__brand top-menu-brand">
                <img v-if="coreParams.shop_asset_image && coreParams.shop_asset_image.logo_original" v-show="showLogo"
                     :src="coreParams.shop_asset_image.logo_original" :alt="shopId" @load="showLogo = true">
                <template v-if="coreParams.title && !showLogo">{{ coreParams.title }}</template>
                <template v-else-if="!showLogo">{{ shopId }}</template>
            </router-link>
            <ul>
                <li v-for="(page, i) in pages" :key="i">
                    <a href="#" @click.prevent="goTo(page.path)" :class="{active: isActiveRoute(page.path)}">
                        <span class="text-with-icon">{{ page.name }}</span>
                        <span v-if="page.lockIcon" class="material-icon" :class="!!customerAlbums.length ? 'icon-lock_open' : 'icon-lock_outline'"/>
                    </a>
                </li>
            </ul>
        </nav>
    </transition>
</template>

<style lang="scss" scoped>
    @import "../scss/variables";

    .sidebar {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        width: $sidebar-width;
        height: 100%;
        padding: 40px;
        top: 0;
        left: 0;
        z-index: 3;
        color: #333;
        background-color: var(--bg-color);
        box-shadow: 0 24px 38px 3px rgba(#000, .14), 0 8px 46px 8px rgba(#000, .12), 0 11px 15px -7px rgba(#000, .2);

        @media (max-width: 960px) {
            width: $sidebar-width-sm;
        }

        &__brand {
            margin-bottom: 100px;
        }

        > ul {
            width: 100%;
            margin: 0;
            padding: 0;
            list-style: none;

            > li {
                padding: 4px 0;
                text-align: center;

                > a {
                    display: flex;
                    align-items: center;
                    padding: .5rem 1.75rem;
                    height: 54px;
                    border-radius: 27px;
                    font-size: 1.25rem;
                    text-decoration: none;
                    text-transform: uppercase;
                    color: #7f7f7f;

                    &:hover,
                    &.active {
                        color: var(--text-color);
                        background-color: var(--bg-secondary-color-dark);
                    }

                    .text-with-icon {
                        margin-right: .4rem;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all .3s ease;
    }

    .fade-enter,
    .fade-leave-to {
        left: -$sidebar-width;

        @media (max-width: 960px) {
            left: -$sidebar-width-sm;
        }
    }
</style>

<script>
    import sidebar from 'src/mixins/sidebarComponent';

    export default {
        mixins: [sidebar],
    };
</script>
